import { render } from "./PoroModo.vue?vue&type=template&id=ddb8a616"
import script from "./PoroModo.vue?vue&type=script&lang=js"
export * from "./PoroModo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__